/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-07-16 20:53:10
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-19 11:11:51
 * @FilePath: /dbrank_b/src/routes/visualChart/visualConfig.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const FONT_FAMILY = 'Trebuchet MS';

export const xAxisLabelColor = {
  color: '#000',
  fontSize: 12,
  fontFamily: FONT_FAMILY,
}
export const yAxisLabelColor = {
  color: '#000',
  fontSize: 12,
  fontFamily: FONT_FAMILY,
}

export const labelFont = {
  fontFamily: FONT_FAMILY,
}


// WEBPACK FOOTER //
// src/routes/visualChart/visualConfig.js